import React, { Component, createRef } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router";
import ProgressButton from "react-progress-button";
import classNames from "classnames";
import { StateSelection } from "@components/common";
import { AccountService } from "@services";
import utils from "@utils";

import TextLogo from "../../../images/logo-text.svg";
import "./SignUpAgency.scss";

class SignUpAgency extends Component {
	constructor(props) {
		super(props);

		this.state = {
			revealPassword: false,
			revealConfirmPass: false,
			form: {
				OrganizationName: "",
				FirstName: "",
				LastName: "",
				Email: "",
				MobilePhone: "",
				Address: "",
				City: "",
				StateId: "",
				Zip: "",
				Password: "",
				ConfirmPassword: "",
				TermsAccepted: false,
			},
			errors: {
				OrganizationName: false,
				FirstName: false,
				LastName: false,
				Email: false,
				MobilePhone: false,
				Address: false,
				City: false,
				StateId: false,
				Zip: false,
				Password: false,
				ConfirmPassword: false,
				TermsAccepted: false,
			},
		};

		this.passwordRef = createRef();
		this.confirmPassRef = createRef();
		this.submitButtonRef = createRef();
	}

	handleFormChange = event => {
		const {
			target: { name, value, checked },
		} = event;
		if (name === "TermsAccepted") {
			this.setState(prevState => ({ form: { ...prevState.form, [name]: checked } }));
		} else if (name === "MobilePhone") {
			this.setState(prevState => ({
				form: { ...prevState.form, [name]: value.replace(/[a-zA-Z]/gi, "") },
			}));
		} else if (name === "Zip") {
			this.setState(prevState => ({
				form: { ...prevState.form, [name]: value.replace(/\D/g, "") },
			}));
		} else {
			this.setState(prevState => ({ form: { ...prevState.form, [name]: value } }));
		}
	};

	formatPhone = event => {
		const {
			target: { value },
		} = event;
		if (/^\(([\d]{3})\) ([\d]{3})-([\d]{4})$/gi.test(value)) return;
		let MobilePhone = value.replace(/[^\d]/gi, "");
		if (MobilePhone.length > 10) {
			MobilePhone = MobilePhone.substr(0, 10);
		}
		if (MobilePhone.length === 10) {
			MobilePhone = MobilePhone.replace(/^(\d{3})(\d{3})(\d{4})$/gi, "($1) $2-$3");
		}

		this.setState(prevState => ({ form: { ...prevState.form, MobilePhone } }));
	};

	/** Validated all ipnuts associetd with the agency signup form */
	validateForm = () => {
		const {
			form: { ...form },
			errors: { ...errors },
		} = this.state;
		const doPasswordsMatch = form.ConfirmPassword.trim() === form.Password.trim();
		errors.OrganizationName = form.OrganizationName.trim() === "";
		errors.FirstName = form.FirstName.trim() === "";
		errors.LastName = form.LastName.trim() === "";
		errors.Email = form.Email.trim() === "";
		errors.MobilePhone = form.MobilePhone.replace(/\D/gi, "").length !== 10;
		errors.Address = form.Address.trim() === "";
		errors.City = form.Address.trim() === "";
		errors.StateId = form.StateId.trim() === "";
		errors.Zip = form.Zip.trim().length !== 5;
		errors.Password = form.Password.trim().length < 6;
		errors.ConfirmPassword = !doPasswordsMatch || form.ConfirmPassword.trim().length < 6;
		errors.TermsAccepted = !form.TermsAccepted;

		this.setState({ errors });
		// If any of the error keys have a value of true, this method will return false;
		return Object.values(errors).filter(err => err === true).length === 0;
	};

	checkForEnter = event => {
		if (event.key === "Enter") {
			this.submitButtonRef.loading();
			this.handleSignUp();
		}
	};

	toggleRevealPassword = id => {
		this.setState(
			prevState => ({ [id]: !prevState[id] }),
			() => {
				switch (id) {
					case "revealPassword":
						this.passwordRef.focus();
						break;
					case "revealConfirmPass":
						this.confirmPassRef.focus();
						break;
					default:
						break;
				}
			},
		);
	};

	/** Gathers and validates all information required for creating a users agency level account */
	handleSignUp = () => {
		if (this.validateForm()) {
			const {
				form: { ...form },
			} = this.state;
			const {
				router: { push },
			} = this.props;
			const { lang } = global;

			form.MobilePhone = form.MobilePhone.replace(/\D/gi, "");
			AccountService.signUp({ data: form })
				.then(({ data }) => {
					this.submitButtonRef.success(() => {
						localStorage.setItem("userId", data.Id);
						push("/confirmation");
					});
				})
				.catch(({ response: { data } }) => {
					this.submitButtonRef.error();
					utils.notify({
						type: "error",
						title: "Error",
						message: data?.Message || lang.t("Error creating account"),
						timeOut: 1500,
					});
				});
		} else {
			this.submitButtonRef.error();
		}
	};

	render() {
		const { lang } = global;
		const {
			form: {
				OrganizationName,
				FirstName,
				LastName,
				Email,
				MobilePhone,
				Address,
				City,
				StateId,
				Zip,
				Password,
				ConfirmPassword,
				TermsAccepted,
			},
			revealPassword,
			revealConfirmPass,
			errors,
		} = this.state;

		return (
			<div
				id="signup-agency"
				className="container-fluid"
			>
				<div className="row">
					<img
						src={TextLogo}
						alt="RollKall"
						className="img-responsive"
					/>
				</div>
				<div className="row">
					<div className="col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3">
						<div
							id="signup-info"
							className="container-fluid"
						>
							<h3 className="text-center">{lang.t("Security Agency Signup")}</h3>
							<p>
								{`${lang.t("Thank you for your interest in utilizing RollKall to assist you with the coordination of your extra duty jobs_")}
								${lang.t("The safety of our officers and our clients is the most important thing we do")}
								${lang.t("so please understand that all submissions are subject to background checks and approval by RollKall_")}`}
							</p>
							<p>
								<strong>{lang.t("Are you a Law Enforcement Agency_")}</strong>
								&nbsp;
								<Link
									id="lea-signup-button"
									to="/signup-lea"
								>
									Click Here
								</Link>
							</p>
							<div className="row">
								<div className="col-sm-12 form-group">
									<label htmlFor="agency-name">{lang.t("Agency Name")}</label>
									<input
										id="agency-name"
										name="OrganizationName"
										className={classNames("form-control", {
											"has-error": errors.OrganizationName,
										})}
										value={OrganizationName}
										onChange={this.handleFormChange}
									/>
								</div>
							</div>
							<div className="row">
								<div className="col-sm-6 form-group">
									<label htmlFor="first-name">{lang.t("First Name")}</label>
									<input
										id="first-name"
										name="FirstName"
										className={classNames("form-control", {
											"has-error": errors.FirstName,
										})}
										value={FirstName}
										onChange={this.handleFormChange}
									/>
								</div>
								<div className="col-sm-6 form-group">
									<label htmlFor="last-name">{lang.t("Last Name")}</label>
									<input
										id="last-name"
										name="LastName"
										className={classNames("form-control", {
											"has-error": errors.LastName,
										})}
										value={LastName}
										onChange={this.handleFormChange}
									/>
								</div>
							</div>
							<div className="row">
								<div className="col-sm-6 form-group">
									<label htmlFor="email-address">{lang.t("EMail")}</label>
									<input
										type="email"
										id="email-address"
										name="Email"
										className={classNames("form-control", {
											"has-error": errors.Email,
										})}
										value={Email}
										onChange={this.handleFormChange}
									/>
								</div>
								<div className="col-sm-6 form-group">
									<label htmlFor="phone-number">{lang.t("Phone")}</label>
									<input
										id="phone-number"
										name="MobilePhone"
										className={classNames("form-control", {
											"has-error": errors.MobilePhone,
										})}
										placeholder="(123) 456 7890"
										maxLength="10"
										value={MobilePhone}
										onChange={this.handleFormChange}
										onBlur={this.formatPhone}
									/>
								</div>
							</div>
							<div className="row">
								<div className="col-sm-12 form-group">
									<label htmlFor="address">{lang.t("Address")}</label>
									<input
										id="address"
										name="Address"
										className={classNames("form-control", {
											"has-error": errors.Address,
										})}
										value={Address}
										onChange={this.handleFormChange}
									/>
								</div>
							</div>
							<div className="row">
								<div className="col-sm-12 form-group">
									<label htmlFor="city">{lang.t("City")}</label>
									<input
										id="city"
										name="City"
										className={classNames("form-control", {
											"has-error": errors.City,
										})}
										value={City}
										onChange={this.handleFormChange}
									/>
								</div>
							</div>
							<div className="row">
								<div className="col-sm-6 form-group">
									<label htmlFor="state-id">{lang.t("State")}</label>
									<StateSelection
										id="state-id"
										name="StateId"
										className={classNames("form-control", {
											"has-error": errors.StateId,
										})}
										value={StateId}
										onChange={this.handleFormChange}
									/>
								</div>
								<div className="col-sm-6 form-group">
									<label htmlFor="zipcode">{lang.t("Zip Code")}</label>
									<input
										id="zipcode"
										name="Zip"
										className={classNames("form-control", {
											"has-error": errors.Zip,
										})}
										maxLength="5"
										value={Zip}
										onChange={this.handleFormChange}
									/>
								</div>
							</div>
							<div className="row">
								<div className="col-sm-6 form-group">
									<label htmlFor="password">{lang.t("Password")}</label>
									<input
										type={revealPassword ? "text" : "password"}
										id="password"
										name="Password"
										ref={ref => {
											this.passwordRef = ref;
										}}
										className={classNames("form-control input-padded-right", {
											"has-error": errors.Password,
										})}
										value={Password}
										onChange={this.handleFormChange}
										onKeyPress={this.checkForEnter}
									/>
									<button
										tabIndex="-1"
										type="button"
										id="revealPassword"
										aria-label="Reveal password"
										title={lang.t(
											revealPassword ? "Hide password" : "Reveal password",
										)}
										className={`btn btn-link rkf ${revealPassword ? "rkf-eye-hidden" : "rkf-eye"}`}
										onClick={({ target: { id } }) =>
											this.toggleRevealPassword(id)
										}
									/>
								</div>
								<div className="col-sm-6 form-group">
									<label htmlFor="confirm-password">
										{lang.t("Confirm Password")}
									</label>
									<input
										type={revealConfirmPass ? "text" : "password"}
										id="confirm-password"
										name="ConfirmPassword"
										ref={ref => {
											this.confirmPassRef = ref;
										}}
										className={classNames("form-control input-padded-right", {
											"has-error": errors.ConfirmPassword,
										})}
										value={ConfirmPassword}
										onChange={this.handleFormChange}
										onKeyPress={this.checkForEnter}
									/>
									<button
										tabIndex="-1"
										type="button"
										id="revealConfirmPass"
										aria-label="Reveal confirm password"
										title={lang.t(
											revealConfirmPass ? "Hide password" : "Reveal password",
										)}
										className={`btn btn-link rkf ${revealConfirmPass ? "rkf-eye-hidden" : "rkf-eye"}`}
										onClick={({ target: { id } }) =>
											this.toggleRevealPassword(id)
										}
									/>
								</div>
								<div className="col-sm-12 text-center text-muted">
									<small>
										{lang.t("Password must be at least 6 characters long")}
									</small>
								</div>
							</div>
							<div className="row">
								<div
									className={classNames("col-sm-12 checkbox", {
										"text-danger": errors.TermsAccepted,
									})}
								>
									<label htmlFor="terms-accepted">
										<input
											type="checkbox"
											name="TermsAccepted"
											id="terms-accepted"
											checked={TermsAccepted}
											onChange={this.handleFormChange}
										/>
										{`${lang.t("I agree to the")} `}
										<a
											href="https://www.rollkall.com/terms-agencies"
											target="_blank"
											rel="noopener noreferrer"
										>
											{lang.t("Terms of Service")}
										</a>
										{` ${lang.t("And").toLowerCase()} `}
										<a
											href="https://www.rollkall.com/privacy"
											target="_blank"
											rel="noopener noreferrer"
										>
											{lang.t("Privacy Policy")}
										</a>
									</label>
								</div>
							</div>
							<div
								id="button-container"
								className="row"
							>
								<div className="col-xs-6 col-sm-3 col-sm-offset-3 text-center">
									<Link
										className="btn btn-link"
										to="/login"
									>
										{lang.t("Cancel")}
									</Link>
								</div>
								<div className="col-xs-6 col-sm-3">
									<ProgressButton
										ref={ref => {
											this.submitButtonRef = ref;
										}}
										className="btn btn-primary"
										onClick={this.handleSignUp}
									>
										{lang.t("Submit")}
									</ProgressButton>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

SignUpAgency.propTypes = { router: PropTypes.object.isRequired };

export default SignUpAgency;
